import React from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonTitle } from 'web-ui-components/lib/atoms/buttons';
import { Icon } from 'web-ui-components/lib/atoms/iconography';

const sortCodeRegEx = /(\d{2})(?=\d)/g;
const sortCodeLength = 6;

export const formatSortCode = (sortCode = '') => {
  const result =
    sortCode.length === sortCodeLength ? sortCode.replace(sortCodeRegEx, '$1-') : sortCode;
  return result;
};

export const CardSelector = ({ title, iconType, onClick, selectedAccount, disabled }) => {
  const renderSelectedCard = () => (
    <button
      className="c-m-payment-control__selected c-m-payment-control__selected--is-visible c-a-button--secondary"
      onClick={onClick}
      disabled={disabled}
    >
      <span className="c-m-payment-control__selected-name">{selectedAccount.displayName}</span>
      <span className="c-m-payment-control__selected-meta">
        {selectedAccount.type === 'credit_card'
          ? selectedAccount.number
          : `${formatSortCode(selectedAccount.sortCode)} | ${selectedAccount.accountNumber}`}
      </span>
    </button>
  );
  const renderSelectorCard = () => (
    <Button display="secondary" onClick={onClick} disabled={disabled}>
      <Icon iconType={iconType} />
      <ButtonTitle>{title}</ButtonTitle>
    </Button>
  );

  return selectedAccount ? renderSelectedCard() : renderSelectorCard();
};

CardSelector.propTypes = {
  title: PropTypes.string.isRequired,
  iconType: PropTypes.string.isRequired,
  selectedAccount: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    sortCode: PropTypes.string,
    type: PropTypes.string.isRequired,
    number: PropTypes.string,
    accountNumber: PropTypes.string,
  }),
  onClick: PropTypes.func.isRequired,
};

export default CardSelector;
